export const CANCELATION_POLICY = "CANCELATION_POLICY";
export const SET_FILTERS_OPTIONS_SYSTEM = "SET_FILTERS_OPTIONS_SYSTEM";
